import { Directive, ElementRef, inject } from '@angular/core'

/**
 * Allow to access the ElementRef and its nativeElement directly in template.
 *
 * Usage:
 * ```html
 * <div #myRef="elementRef"></div>
 * <div *ngIf="myRef.nativeElement.classList.contains('foo')"></div>
 * ```
 */
@Directive({
	selector: '[mosElementRef]',
	exportAs: 'elementRef',
})
export class ElementRefDirective {
	elementRef = inject(ElementRef)

	public nativeElement: Element

	constructor() {
		const elementRef = this.elementRef

		this.nativeElement = elementRef.nativeElement
	}
}
